
import { withInstall } from '/@/utils';

import appLogo from './src/AppLogo.vue';
import appBlackLogo from './src/AppBlackLogo.vue';
import appProvider from './src/AppProvider.vue';
import appSearch from './src/search/AppSearch.vue';
import appLocalePicker from './src/AppLocalePicker.vue';


export { useAppProviderContext } from './src/useAppContext';

export const AppBlackLogo = withInstall(appBlackLogo);

export const AppLogo = withInstall(appLogo);
export const AppProvider = withInstall(appProvider);
export const AppSearch = withInstall(appSearch);
export const AppLocalePicker = withInstall(appLocalePicker);
